import { render, staticRenderFns } from "./ConfirmarCancelarConsulta.vue?vue&type=template&id=7b98b7c8&scoped=true"
import script from "./ConfirmarCancelarConsulta.vue?vue&type=script&lang=js"
export * from "./ConfirmarCancelarConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b98b7c8",
  null
  
)

export default component.exports